$(document).ready(function(){
  
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
  
  var winW = $(window).width();
	
	 $('#main-photo ul').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '#mini-photos ul'
	});
	$('#mini-photos ul').slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
      vertical: true,
	  asNavFor: '#main-photo ul',
	  dots: false,
	  arrows: false,
	  centerMode: false,
	  focusOnSelect: true,
      responsive: [
        {
          breakpoint: 830,
          settings: {
            vertical: false,
          }
        }
      ]
	});
	
	
	// Header
	
	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
  
    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
	
	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');	
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');	
	});
	
	$('header .show-menu').click(function(){
		$('nav').addClass('show');
	});
  
	$('header nav .cerrar').click(function(){
		$('nav').removeClass('show');	
        $('#smenu').removeClass('show');
	});
  
    $('header nav li.site-nav--has-dropdown').each(function(){
      var left = $(this).find('.sub-menu').offset().left;
      console.log('left: ' + left);
      $(this).find('.sub-menu .after').css({ 'left' : -left });
    });
  
    $('nav > ul > li:nth-child(1) > a').removeAttr('href');
  
    if ( winW > 830 ) {
      
      $('nav li:nth-child(1)').click(function(){
        $('#smenu').slideToggle(150);
      });
      
    } else {
      
      $('nav li:nth-child(1)').click(function(){
        $('#smenu').toggleClass('show');
        $('#smenu .main-smenu.show').removeClass('show');
      });
      
      $('#smenu .sub-cat').each(function(){
        $(this).click(function(){
          $(this).next().toggleClass('show');
          $(this).siblings('.sub-cat').next().removeClass('show');
        });
      });
      
    }
  
    

  	// Product

    $('.product .left .content .deon > h2').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h2').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .left .content .deon h2').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });
  
    $('.product .left .content .deon h2:nth-child(1)').toggleClass('active');
    $('.product .left .content .deon h2:nth-child(1)').next('.hide-info').toggleClass('show');
  
  
    $('.product .right .content .deon > h2').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h2').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .right .content .deon h2').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });
  
    $('.product .right .content .deon h2:nth-child(1)').toggleClass('active');
    $('.product .right .content .deon h2:nth-child(1)').next('.hide-info').toggleClass('show');
  
  
    if ( winW < 830 ) {
      //$('nav ul.menu > li.site-nav--has-dropdown > a').removeAttr('href');
      
      $('nav ul.menu > li.site-nav--has-dropdown > a').each(function(){
        var href = $(this).attr('href');
        console.log('href: ' + href);
        
        $(this).click(function(e){
        	e.preventDefault();
            $(this).click(function(){
				//window.location.href = href;
            });
        });
        
      });
      
      $('nav ul.menu > li.site-nav--has-dropdown').click(function(){
        $(this).siblings().children('.sub-menu').removeClass('show');
        $(this).children('.sub-menu').toggleClass('show');
      });
    }
  
  
    // Nuevo Menu
  
  
	
	$('header .row2 .showmenu').click(function(){
		$('header .row2 .clear>div.menu').toggleClass('show');
	});
  
  
    $('header .row2 .clear>div.menu li.site-nav--has-dropdown > a').each(function(){
        var href = $(this).attr('href');
        console.log('href: ' + href);
        
        $(this).click(function(e){
        	e.preventDefault();
            $(this).click(function(){
				//window.location.href = href;
            });
        });
      });
  
  	$('header .row2 .clear>div.menu li.site-nav--has-dropdown').click(function(){
      //$(this).siblings().children('.sub-menu').removeClass('show');
      //$(this).children('.sub-menu').toggleClass('show');
      $(this).siblings().children('.sub-menu').slideUp(100);
      $(this).children('.sub-menu').slideToggle(200);
    });
  
  
    // Pop Up  
  
    $('#popup .cerrar').click(function(){
      $('#popup').removeClass('show');
    });

    //$('#popup').addClass('show');

    if (!Cookies.get('showed_newsletter')) {
      setTimeout(function(){
        //$('#popup').addClass('show');
        Cookies.set('showed_newsletter', 'true', { expires: 7 });
      },2000) // 3 seconds.
    }
	
});